export default {
  "interviews.detail.pageTitle": "インタビュー・コラム",
  "interviews.detail.head.siteName": "LINK-J",

  "interviews.list.head.title": "インタビュー・コラム一覧 | LINK-J",
  "interviews.list.head.description":
    "ライフサイエンス分野のスタートアップやベンチャーのCEOをはじめ、ステークホルダーへのスペシャルインタビュー、ライフサイエンス関連のコラム記事を掲載しています。",
  "interviews.list.head.siteName": "LINK-J",
  "interviews.list.title": "インタビュー・コラム",
  "interviews.list.heading.title": "インタビュー・コラム一覧",

  "interviews.categories.special-interviews": "スペシャルインタビュー",
  "interviews.categories.start-up-interviews": "ベンチャーインタビュー",
  "interviews.categories.supporter": "会報誌（News Letter）",
  "interviews.categories.serial-column": "連載コラム",
  "interviews.categories.supporter-column": "サポーターコラム",
  "interviews.categories.column": "日本橋コラム",
  "interviews.categories.link-j-staff-blog": "事務局だより",
  "interviews.categories.interview": "インタビュー・コラム一覧",
  "interviews.categories.researcher-interviews": "Researcher Interviews",
} as const;
